<template>
    <div class="ReportsPane">
        <div class="container-fluid container-fill">
            <div class="row">
                <div class="col-md-4">
                    <h4>Licensing Reports</h4>
                    <ReportDownloader report-label="Training Records"
                                      endpoint="Foster/Reports/FamilyReports/GetPNWFamilyTrainingReport"
                                      :parameter-schema="ParamsIdDate"
                                      report-description="Generates an excel document listing the trainings recorded for this family for the 3 year period preceding the Licensing Period End Date." />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faList } from '@fortawesome/free-solid-svg-icons';
    library.add(faList);
    import { faChild } from '@fortawesome/free-solid-svg-icons';
    library.add(faChild);
    //import components
    import ReportDownloader from '../../../Core/UI/ReportDownloader.vue';
    export default {
        props: ["FamilyRecordData"],
        data: function () {
            return {
                ParamsIdDate: [
                    {
                        Label: "Family:",
                        Name: "Id",
                        Type: "HiddenConstant",
                        DisplayValue: "",
                        Value: ""
                    },
                    {
                        Label: "Licensing Period (#):",
                        Name: "LicensingPeriodNumber",
                        Type: "Number",
                        Required: true
                    },
                    {
                        Label: "Licensing Period End Date:",
                        Name: "Date",
                        Type: "Date",
                        Required: true
                    }
                ]
            };
        },
        methods: {

        },
        computed: {
        },
        components: {
            ReportDownloader
        },
        mounted() {
            this.ParamsIdDate[0].Value = this.FamilyRecordData.Id;
            this.ParamsIdDate[0].DisplayValue = this.FamilyRecordData.Family.Name;
        }
    }
</script>

<style scoped>
</style>